import { render, staticRenderFns } from "./CNavBlockSns.vue?vue&type=template&id=d4207584&"
import script from "./CNavBlockSns.vue?vue&type=script&lang=ts&"
export * from "./CNavBlockSns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports